/* eslint-disable */
import { Theme, createStyles } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    mainContainer: {
      padding: "18px",
      paddingTop: "0px",
      paddingBottom: "20vh",
      display: "grid",
      [theme.breakpoints.up("xs")]: {
        gridTemplateColumns: "repeat(2, 1fr)",
      },
    },
    cardContainer: {
      boxShadow: "0px 2px 4px rgba(28, 41, 90, 0.0367952)",
      borderRadius: "12px",
      border: "1px solid #EAEDF7",
      padding: "20px",
      margin: "6px",
    },
    cardContent: {
      padding: "0px",
      "&:nth-child(1)": {
        paddingBottom: 0,
      },
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
    materialIcons: {
      paddingBottom: "12px",
      color: "#97A0C3",
    },
    materialIconsFile: {
      paddingBottom: "12px",
      color: "#AE0064",
      fontSize: "24px",
    },
    docName: {
      textAlign: "center",
      fontSize: "16px",
      "font-weight": "bold",
      wordWrap: "break-word",
    },
    backContainer: {
      paddingBottom: "0px",
      display: "flex",
      justifyContent: "left",
      size: "small",
      padding: "24px",
    },
    fab: {
      borderRadius: "12px",
      backgroundColor: "white",
      margin: "1%",
      boxShadow: "0px 12px 30px rgba(37, 34, 117, 0.08)",
      height: "36px",
      width: "36px",
      padding: "12px",
    },
    arrow: {
      fontSize: "18px",
      display: "flex",
      justifyContent: "center",
      marginLeft: "6px",
      stroke: "black",
    },
    breadcrumbLink: {
      color: "black",
    },
    title: {
      fontWeight: "bolder",
      fontSize: "16px",
      margin: "24px",
      marginBottom: "6px",
      marginTop: "24px",
    },
    breadcrumbLinkModal: {
      color: "black",
      display: "flex",
    },
    breadcrumbLinkTypography: {
      marginTop: "12px",
      display: "flex",
      alignItems: "flex-start",
      fontSize: "24px",
      "font-weight": "bold",
    },
    breadcrumbLinkTypographyModal: {
      display: "flex",
      alignItems: "flex-start",
      fontSize: "24px",
      "font-weight": "bold",
      paddingLeft: "12px",
    },
  });
